var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDataVaultIcon = function SvgDataVaultIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.519,
    height: 48.519
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "data-vault-icon_svg__a",
    width: 48.519,
    height: 48.519,
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Data Vault"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#data-vault-icon_svg__a)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 251",
    style: {
      fill: "#467181",
      stroke: "#fff"
    },
    transform: "rotate(-1 435.406 -570.448)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    stroke: "none",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14.5,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M7.5-14h-15A1.5 1.5 0 0 0-9-12.5v10A1.5 1.5 0 0 0-7.5-1h15A1.5 1.5 0 0 0 9-2.5v-10A1.5 1.5 0 0 0 7.5-14M7-3H-7v-9H7z",
    "data-name": "Secondary Layer",
    style: {
      opacity: 0.5,
      fill: "#fff"
    },
    transform: "translate(24.26 27.26)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25.5H2L1.5-1h-3L-2 .5h-2.25a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h8.5a.75.75 0 0 0 0-1.5M-7-12v9H7v-9z",
    "data-name": "Primary Layer",
    style: {
      fill: "#fff"
    },
    transform: "translate(24.26 27.26)"
  })));
};
export { SvgDataVaultIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OC41MTkiIGhlaWdodD0iNDguNTE5IiB2aWV3Qm94PSIwIDAgNDguNTE5IDQ4LjUxOSI+CiAgICA8ZGVmcz4KICAgICAgICA8ZmlsdGVyIGlkPSJ4dzN4NWVvcm1hIiB4PSIwIiB5PSIwIiB3aWR0aD0iNDguNTE5IiBoZWlnaHQ9IjQ4LjUxOSIgZmlsdGVyVW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KICAgICAgICAgICAgPGZlT2Zmc2V0IGR5PSIzIi8+CiAgICAgICAgICAgIDxmZUdhdXNzaWFuQmx1ciBzdGREZXZpYXRpb249IjMiIHJlc3VsdD0iYmx1ciIvPgogICAgICAgICAgICA8ZmVGbG9vZCBmbG9vZC1vcGFjaXR5PSIuMTYxIi8+CiAgICAgICAgICAgIDxmZUNvbXBvc2l0ZSBvcGVyYXRvcj0iaW4iIGluMj0iYmx1ciIvPgogICAgICAgICAgICA8ZmVDb21wb3NpdGUgaW49IlNvdXJjZUdyYXBoaWMiLz4KICAgICAgICA8L2ZpbHRlcj4KICAgIDwvZGVmcz4KICAgIDxnIGRhdGEtbmFtZT0iRGF0YSBWYXVsdCI+CiAgICAgICAgPGcgc3R5bGU9ImZpbHRlcjp1cmwoI3h3M3g1ZW9ybWEpIj4KICAgICAgICAgICAgPGcgZGF0YS1uYW1lPSJFbGxpcHNlIDI1MSIgdHJhbnNmb3JtPSJyb3RhdGUoLTEgNDM1LjQwNiAtNTcwLjQ0OCkiIHN0eWxlPSJmaWxsOiM0NjcxODE7c3Ryb2tlOiNmZmYiPgogICAgICAgICAgICAgICAgPGNpcmNsZSBjeD0iMTQiIGN5PSIxNCIgcj0iMTQiIHN0eWxlPSJzdHJva2U6bm9uZSIvPgogICAgICAgICAgICAgICAgPGNpcmNsZSBjeD0iMTQiIGN5PSIxNCIgcj0iMTQuNSIgc3R5bGU9ImZpbGw6bm9uZSIvPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgICAgIDxwYXRoIGRhdGEtbmFtZT0iU2Vjb25kYXJ5IExheWVyIiBkPSJNNy41LTE0aC0xNUExLjUgMS41IDAgMCAwLTktMTIuNXYxMEExLjUgMS41IDAgMCAwLTcuNS0xaDE1QTEuNSAxLjUgMCAwIDAgOS0yLjV2LTEwQTEuNSAxLjUgMCAwIDAgNy41LTE0ek03LTNILTd2LTlIN3oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI0LjI2IDI3LjI2KSIgc3R5bGU9Im9wYWNpdHk6LjU7ZmlsbDojZmZmIi8+CiAgICAgICAgPHBhdGggZGF0YS1uYW1lPSJQcmltYXJ5IExheWVyIiBkPSJNNC4yNS41SDJMMS41LTFoLTNMLTIgLjVoLTIuMjVhLjc1Ljc1IDAgMCAwLS43NS43NS43NS43NSAwIDAgMCAuNzUuNzVoOC41YS43NS43NSAwIDAgMCAwLTEuNXpNLTctMTJ2OUg3di05eiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjQuMjYgMjcuMjYpIiBzdHlsZT0iZmlsbDojZmZmIi8+CiAgICA8L2c+Cjwvc3ZnPgo=";